import clsx from 'clsx'
import React from 'react'

import Styles from './Spinner.module.scss'

type Props = {
  size?: 'small' | 'medium' | 'large'
  color?: 'default' | 'white'
  className?: string
}

// same multipliers are in scss
const MULTIPLIERS_BY_SIZE = {
  small: 0.2,
  medium: 0.5,
  large: 1
}
const DEFAULT_CIRCLE_SIZE = 40

const Spinner = React.memo(({ size = 'medium', color = 'default' }: Props) => {
  const circleSize = MULTIPLIERS_BY_SIZE[size] * DEFAULT_CIRCLE_SIZE

  return (
    <svg
      data-testid="loading-spinner"
      data-size={size}
      data-color={color}
      className={clsx(Styles[size], Styles[color])}>
      <circle cx={circleSize} r={circleSize} cy={circleSize} />
    </svg>
  )
})

Spinner.displayName = 'Spinner'
export default Spinner
